import './detail-class.scss';
//library
import format from 'date-fns/format';
import es from 'date-fns/locale/es';
//shared

//material
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, IconButton, Grid } from '@mui/material';

function createCol(
    name: string
) {
    return { name };
}

let cols = [createCol('Inscritos'), createCol('Tomadas'), createCol('Canceladas'), createCol('No asistidas'), createCol('Cancelada tarde')];

function InformationClass({ dataClass }: { dataClass: any }) {

    return (
        <>
            <TableContainer className='container-attendance' component={Paper}>
                <Table sx={{ minWidth: 250 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {cols.map((col) => (
                                <TableCell key={col.name} align="center">{col.name}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={dataClass.calendar.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell align="center" component="th" scope="row"> {dataClass.total} </TableCell>
                            <TableCell align="center" component="th" scope="row"> {dataClass.taked} </TableCell>
                            <TableCell align="center" component="th" scope="row"> {dataClass.canceled} </TableCell>
                            <TableCell align="center" component="th" scope="row"> {dataClass.noShow} </TableCell>
                            <TableCell align="center" component="th" scope="row"> {dataClass.lateCancel} </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default function DetailClass({ attendance, dataCalendar }: { attendance: () => void, dataCalendar: any }) {
    return (
        <Box>
            <div className='container-body'>
                <h1>Historial</h1>
            </div>
            <Grid container>
                <Grid item xs={8} className='container-body'>
                    <IconButton onClick={() => attendance()}>
                        <ArrowBackIcon />
                    </IconButton>
                    <h2>{dataCalendar.calendar.classFit.name}</h2>
                    <h3>{format(new Date(dataCalendar.calendar.start), "dd 'de' MMMM 'de' yyyy", { locale: es })}</h3>
                    <h4>{format(new Date(dataCalendar.calendar.start), "HH:mm")}</h4>
                </Grid>
            </Grid>
            <InformationClass dataClass={dataCalendar}></InformationClass>
        </Box>
    );
}